'use strict';

var Backbone    = require('backbone');
var path        = require('path');

// Client routes
var company         = require('./../client/company/.routes');
var companyIndex    = require('./../client/company-index/.routes');
var mic             = require('./../client/mic/.routes');
var micIndex        = require('./../client/mic-index/.routes');
var sector          = require('./../client/sector/.routes');

// Set the order of the routes
var routesList = [
    company.config[0],
    companyIndex.config[0],
    mic.config[0],
    micIndex.config[0],
    sector.config[0],
    sector.config[1]
];

// Build the routes object
var routes = {},
    routesEvents = [],
    i;
for (i = 0; i < routesList.length; i++) {
    routes[routesList[i].view.route] = routesList[i].view.alias;
    routesEvents.push({
        route: `route:${routesList[i].view.alias}`,
        filePath: path.join('./../../', routesList[i].view.file)
    });
}

// Set all the client routes
var AppRouter = Backbone.Router.extend({
    routes: routes
});

// Create the router and the router events
var router = new AppRouter();
router.on('route:company', require('../../app/client/company/js/company.js'));
router.on('route:company-index', require('../../app/client/company-index/js/company-index.js'));
router.on('route:mic', require('../../app/client/mic/js/mic.js'));
router.on('route:most-innovative-companies', require('../../app/client/mic/js/mic.js'));
router.on('route:mic-index', require('../../app/client/mic-index/js/mic-index.js'));
router.on('route:sector', require('../../app/client/sector/js/sector.js'));
router.on('route:sector-index', require('../../app/client/sector/js/sector.js'));

module.exports = router;
